







import * as Util from '@/util.ts';
import Vue from 'vue';

export default Vue.extend({
  props: {
    bill: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
    onClick: {
      type: Function,
      default: (): void => undefined,
    },
  },
  computed: {
    name(): string {
      return Util.t?.billName.supplant([this.$props.index + 1]);
    },
    total(): string {
      const bill: Bill = this.$props.bill;
      if (bill.orderItems) {
        const numOfItems = bill.orderItems.length;
        return Util.t?.billForItemsTotal.supplant([numOfItems, Util.formatCurrency(this.$props.bill.total, false)]);
      }
      const numOfSplits = Object.values(bill.splitOrderItems as SplitOrderItems).length;
      return Util.t?.splitBillForItemsTotal.supplant([numOfSplits, Util.formatCurrency(this.$props.bill.total, false)]);
    },
  },
});
